import { MutableRefObject, ReactNode, RefCallback, RefObject } from "react";

export function isNullOrEmpty(value: any) {
    if (value === undefined) return true;
    if (value === null) return true;
    if (value === "") return true;
    return false;
}

export function removeNullOrEmptyKeys(object: any) {
    if (typeof object !== "object") return object;

    const newObject: Record<string, any> = {};
    Object.keys(object).forEach(key => {
        if (!isNullOrEmpty(object[key])) newObject[key] = object[key]
    });
    return newObject;
};

export function sleep(ms: number): Promise<void> {
    const mode = import.meta.env.MODE;
    if (mode !== "development") return new Promise(resolve => resolve());
    return new Promise(resolve => setTimeout(resolve, ms));
}

type Model = { id: string } & Record<string, any>;

export function mergeModelArrays<T extends Model>(...arrays: (T[] | undefined | null | false)[]): T[] {
    const ret: T[] = [];
    for (const array of arrays) {
        if (array) {
            for (const model of array) {
                if (!ret.find(m => m.id === model.id)) ret.push(model);
            }
        }
    }
    return ret;
}

export function extractText(node: ReactNode): string {
    if (node == null)
        return String(node);
    if (typeof node === "string" || typeof node === "number" || typeof node === "boolean")
        return String(node);
    if (typeof node === "object" && Symbol.iterator in node)
        return Array.from(node).map(n => extractText(n)).join(" ");
    if ("value" in node.props)
        return extractText(node.props.value);
    if ("label" in node.props)
        return extractText(node.props.label);
    return extractText(node.props.children)
}

export function mergeRefs(...refs: (RefCallback<any> | RefObject<any> | MutableRefObject<any> | undefined | null | false)[]) {
    function mergeRefsFunction(element: any, ...refs: (RefCallback<any> | MutableRefObject<any> | undefined | null | false)[]) {
        for (const ref of refs) {
            if (ref) {
                if (typeof ref == "function") {
                    ref(element);
                } else {
                    ref.current = element;
                }
            }
        }
    }

    return (element: any) => mergeRefsFunction(element, ...refs as any[]);
}